import React from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";
import xpImg1 from "../assets/xp1.jpg"; 
import xpImg2 from "../assets/xp2.jpg"; 
import "./Sobre.css";

const Sobre = () => {
  return (
    <>
      <Header2 />

      {/* Primeira seção: imagem à esquerda, texto à direita */}
      <section className="experience-section">
        <h2 className="experience-heading">NOSSA HISTÓRIA</h2>
        <div className="experience-content">
          <div className="experience-left-content">
            <img src={xpImg1} alt="Experiência Portugal" className="experience-image" />
          </div>

          <div className="experience-right-content">
            <p className="experience-description">
              A Retroflex nasceu onde muitos não imaginariam: em uma garagem emprestada, durante a quarentena em Portugal. Quando o mundo parou e tudo fechou, o único espaço para manter o treino vivo era a garagem de um amigo.
            </p>
            <p className="experience-description">
              Ali, com gratidão e vontade de continuar, começamos a transformar aquele espaço simples em algo maior. Compramos algumas máquinas usadas para deixar o local mais completo, como uma extensora de pernas que custou poucos euros, mas surpreendeu pela qualidade.
            </p>
            <p className="experience-description">
              Foi a primeira vez que vimos que era possível construir algo grande com poucos recursos e muita vontade. Cada máquina tinha sua história. Descobrimos marcas renomadas, como a Tecnogym e a Cybex, em oportunidades inesperadas.
            </p>
            <p className="experience-description">
              O interesse foi crescendo, e com ele a coleção de equipamentos. Quando voltei ao Brasil, a ideia era simples: montar uma garagem própria e continuar treinando. As primeiras cinco máquinas foram compradas no Mercado Livre e ficaram paradas por mais de um ano, aguardando minha volta, por causa das restrições nos aeroportos.
            </p>
          </div>
        </div>
      </section>

      {/* Segunda seção: texto à direita, imagem à esquerda */}
      <section className="experience-section">
        <div className="experience-content reverse">
          <div className="experience-left-content">
            <img src={xpImg2} alt="Experiência Brasil" className="experience-image" />
          </div>

          <div className="experience-right-content">
            <p className="experience-description">
              Quando finalmente cheguei ao Brasil, e a quarentena bateu à nossa porta por aqui também, comecei a equipar a garagem com tudo o que havia conseguido. Não demorou para todos os cômodos da casa se transformarem em depósitos improvisados de máquinas desmontadas.
            </p>
            <p className="experience-description">
              A vontade de construir algo sólido e a paixão por montar um centro de treinamento de verdade foram maiores do que o espaço disponível em casa. Entre as peças que compõem nossa história está o famoso rack da Cybex, que marcou minha juventude em Porto Alegre.
            </p>
            <p className="experience-description">
              Com a casa tomada pelos equipamentos e um desejo crescente de construir algo maior, alugamos nosso primeiro galpão. Foi lá que o Morais conquistou seu primeiro Olympia, treinando exclusivamente dentro da nossa garagem, e depois, o segundo, já na nova academia.
            </p>
            <p className="experience-description">
              Hoje, a Retroflex é muito mais que uma academia. É um símbolo de superação, de força construída tijolo por tijolo, máquina por máquina, treino por treino. Agora, com nosso projeto de franquias em andamento, estamos prontos para levar essa história e esse espírito para ainda mais lugares. Seja bem-vindo à Retroflex. Aqui, cada detalhe conta. E você faz parte dessa história.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Sobre;
